import React from "react";

const ActivitiesFuneral = () => {
  return (
    <section id="activities-funeral">
      <h1>Temetkezés, temetőüzemeltetés</h1>

      <header>
        <div id="activities-funeral-info">
          <h2>Nyitvatartás:</h2>
          <ul>
            <li>H 9.00-18.00</li>
            <li>K-Cs 8.00-16.00</li>
            <li>P 8.00-13:30</li>
            <li>Sz-V Zárva</li>
          </ul>

          <h2>Temetkezési irodavezető:</h2>
          <ul>
            <li>Nyúzó Józsefné</li>
          </ul>

          <h2>Elérhetőség:</h2>
          <ul>
            <li>
              <a href="tel: +36 59/520-700">59/520-700</a>
            </li>
            <li>
              <a href="tel: +36 30/214-3333">30/214-3333</a>
            </li>
          </ul>

          <h2>Sírhelyváltás:</h2>
          <ul>
            <li>Kása Attila</li>
            <li>
              <a href="tel: +36 20/212-5889">20/212-5889</a>
            </li>
          </ul>
        </div>

        <div id="activities-funeral-img"></div>
      </header>

      <div id="activities-funeral-text">
        <div>
          <p>
            2016. június 13-tól a Kft. kibővítette tevékenységi körét
            temetkezési szolgáltatással, majd ennek kapcsán temetőüzemeltetési
            feladatok ellátásával Kisújszállás város területén.
            <br />A temetkezési szolgáltatási tevékenységhez irodát üzemeltetünk
            Kisújszállás, Dózsa Gy. u. 1. sz. alatt. Itt történik a
            temetésfelvétel, kellékárusítás, teljes körű ügyintézés,
            virágcsokrok, koszorúk készítése. A város és a cég kiemelt
            fontosságúnak tekinti, hogy a lakosok számára kegyelet teljes,
            egyöntetű, nem profit szemlétű szolgáltatást nyújtson.
          </p>
        </div>

        <div>
          <p>
            A cég a Református Egyházzal kötött üzemeltetési szerződés alapján
            ellátja Kisújszállás város közigazgatási területén fekvő, az
            ingatlan-nyilvántartásban 758. helyrajzi számon felvett, 5 ha 3066
            m2 területű, a Kisújszállási Református Egyházközség tulajdonában
            lévő temető, (Nyugati temető), az 1845. helyrajzi számon felvett, 9
            ha 3933 m2 területű, (Déli temető), a 4117. és 4118. helyrajzi
            számokon felvett, 1 ha 6612m2 és 7745m2 területű (Keleti temető
            északi része), valamint a 4113/1. helyrajzi számon nyilvántartott 3
            ha 1934 m2 területű (Keleti temető déli része) temetők
            üzemeltetését.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ActivitiesFuneral;
